'use strict';

const Action = require('./Action');

/**
 * Clase de gestión de una regla de tipo Activar elemento ePRO
 *
 * @extends {Action}
 *
 * @memberOf Structure
 */
class EnableEproAction extends Action {
    /**
     * @inheritDoc
     */
    constructor(rawAction) {
        super(rawAction);

        this.openingFormula = rawAction.openingFormula;
        this.openingTime = rawAction.openingTime;
        this.closingFormula = rawAction.closingFormula;
        this.closingTime = rawAction.closingTime;

        this.type = Action.Types.ENABLE_EPRO;
        this.function = 'enableEpro';
    }

    /**
     * Exportación de la acción en un objeto para la ejecución de las reglas
     *
     * @returns {ExportedHideAction} Objeto de exportación de la acción
     */
    export() {
        const rawAction = super.export();

        rawAction.openingFormula = this.openingFormula;
        rawAction.openingTime = this.openingTime;
        rawAction.closingFormula = this.closingFormula;
        rawAction.closingTime = this.closingTime;

        return rawAction;
    }
}

module.exports = EnableEproAction;
